// extracted by mini-css-extract-plugin
export default {"infoSection":"styles_infoSection__wVWew","title":"styles_title__sk-06"};